import { render } from "./lTime.vue?vue&type=template&id=439f0127&ts=true"
import script from "./lTime.vue?vue&type=script&lang=ts"
export * from "./lTime.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__